import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { Clipboard } from '@angular/cdk/clipboard';
import * as html2pdf from 'html2pdf.js';
import { QuestionnarieService } from '../../../shared/services/questionnarie.service';
import { environment } from '../../../../environments/environment';
import { InstitutionService } from '../../../shared/services/institution.service';

@Component({
  selector: 'ps-questionnarie',
  templateUrl: './questionnarie.component.html',
  styleUrls: ['./questionnarie.component.scss'],
  providers: []
})
export class QuestionnarieComponent implements OnInit {
  public spinner: boolean = false;
  public institutionName: any;
  public institutionId: any;
  public copyLinkRoute: any;
  public institutionIdByRoute: any;
  public showInsName: boolean = false;
  public InsName: any;
  public currentAction: string = '';
  public role: any;
  public questionnarieData: any[] = [];
  public dynamicForm!: FormGroup;
  public showAllSelected: any[] = [];
  public questionnarieTitle!: string;
  public questionnarieNumber: any;
  public isDynamicFormSubmitted: boolean = false;
  public baseIndex = 4;
  public receivedHtml: string = '';
  public studentId: any;
  public questionId: any;
  public questionData: any[] = [];
  public form!: FormGroup;
  public isCallViewPage: boolean = false;
  public index!: number;
  public showTextbox: boolean = false;
  public textBoxValue: string = '';
  public othersFields: { [fieldIndex: number]: boolean } = {};
  public showTextboxes: boolean[] = [];
  public showForm: boolean = false;
  public institutesId: any;
  public otherOptions = ['others', 'Other', 'Others', 'other'];
  public InstituteName: any;
  public showName: boolean = false;
  public quesId: any;

  // TAB HANDLING STATES
  public activeTab: 'student' | 'mentor' = 'student';

  constructor(private fb: FormBuilder, private cdr: ChangeDetectorRef, private router: Router, private InstitutionService: InstitutionService, private route: ActivatedRoute, private clipboard: Clipboard, private questionnarieService: QuestionnarieService, private toastr: ToastrService) { }

  ngOnInit(): void {
    const userString = localStorage.getItem('user');
    if (userString) {
      const user = JSON.parse(userString);
      this.institutionName = user.name;
    }
    this.role = localStorage.getItem('role');
    this.institutesId = this.role === "PORTAL_MENTOR" ? localStorage.getItem('institutionID') : localStorage.getItem('userId');

    this.route.params.subscribe((param) => {
      this.institutionIdByRoute = param.id;
    });

    this.quesId = localStorage.getItem('questionnarieQusId');
    if (this.quesId != "") {
      this.getQuestionnarieFormDetailsById(this.quesId)
    } else {
      this.showForm = true;
    }

    this.dynamicForm = this.fb.group({
      dynamicFields: this.fb.array([]),
      email: ['', [Validators.required, Validators.email]],
      name: ['', [Validators.required, this.noWhitespaceValidator]],
      year: [''],
      address: ['']
    });

    if (this.institutionIdByRoute == undefined) {
      this.showInsName = false;
    } else {
      this.getInstitutionById();
      this.showInsName = true;
    }
  }

  // Function to switch tabs and clear/set validation dynamically
  switchTab(tab: 'student' | 'mentor'): void {
    this.activeTab = tab;
    const emailControl = this.dynamicForm.get('email');

    if (tab === 'mentor') {
      // 1. Mentor tab-la email field hide aaguradhal validator-ah remove pandrom
      emailControl?.clearValidators();

      // 2. Localstorage data fetch & Patching values safely for Mentor
      const mentorName = localStorage.getItem('mentorName');
      const institutionName = localStorage.getItem('institutionName');
      if (mentorName && institutionName) {
        // const user = JSON.parse(userString);

        this.dynamicForm.patchValue({
          name: mentorName || '',      // Extracts mentorName from localstorage
          address: institutionName || '' // Patches institutionName into the 4th field
        });
      }
    } else {
      // Student tab-ku thirumba set pandrom and values clean control reset
      emailControl?.setValidators([Validators.required, Validators.email]);

      this.dynamicForm.patchValue({
        name: '',
        address: ''
      });
    }

    emailControl?.updateValueAndValidity();
    this.cdr.detectChanges();
  }

  noWhitespaceValidator(control: FormControl) {
    const value = control.value;
    if (value == null || typeof value !== 'string') {
      return null;
    }
    const isWhitespace = value.trim().length === 0;
    return isWhitespace ? { whitespace: true } : null;
  }

  getQuestionnarieFormDetailsById(questionnarieId: any) {
    this.spinner = true;
    this.questionnarieService.viewQuestionnarieFormDetailsById(questionnarieId).subscribe((res: any) => {
      if (res.status) {
        this.spinner = false;
        this.questionnarieData = res.data.allQuestionnarie;
        this.questionnarieTitle = res.data.title;
        this.questionnarieNumber = res.data.quesNo;
        this.loadForm(this.questionnarieData);
      } else {
        this.spinner = false;
        this.toastr.error(res.message);
      }
    });
  }

  getGlobalIndex(groupIndex: number, fieldIndex: number): number {
    const groups = this.getChunkedFields();
    let count = 0;
    for (let i = 0; i < groupIndex; i++) {
      count += groups[i].length;
    }
    return count + fieldIndex + 1;
  }

  get dynamicFields(): FormArray {
    return this.dynamicForm.get('dynamicFields') as FormArray;
  }

  loadForm(data: any[]): void {
    const formGroups = data.map(field => {
      const initialShowOtherInput = (Array.isArray(field.value) && field.value.some((val: any) => ['others', 'Other', 'Others', 'other'].includes(val))) ||
        (typeof field.value === 'string' && ['others', 'Other', 'Others', 'other'].includes(field.value));
      return this.fb.group({
        fieldName: [field.fieldName],
        fieldType: [field.fieldType],
        options: [field.options],
        required: [field.required || false],
        needTextbox: [field.needTextbox || false],
        breakLine: [field.breakLine || false],
        value: field.fieldType === 'checkbox' || field.fieldType === 'multiselect' ? this.fb.control(field.value || []) : this.fb.control(field.value || ''),
        formControlName: [field.formControlName || ''],
        otherText: new FormControl(field.otherText || ''),
        showOtherInput: new FormControl(initialShowOtherInput)
      });
    });
    const formArray = this.fb.array(formGroups);
    this.dynamicForm.setControl('dynamicFields', formArray);
  }

  getChunkedFields(): FormGroup[][] {
    const chunks: FormGroup[][] = [];
    const controls = this.dynamicFields.controls as FormGroup[];
    for (let i = 0; i < controls.length; i += 3) {
      chunks.push(controls.slice(i, i + 3));
    }
    return chunks;
  }

  trackByField(index: number, field: AbstractControl): string {
    return field.get('fieldName')?.value || index;
  }

  trackByGroup(index: number, group: AbstractControl[]): number {
    return index;
  }

  saveQuestionnarieForm() {
    this.isDynamicFormSubmitted = true;
    if (this.dynamicForm.valid) {
      const dynamicFieldsArray = this.dynamicForm.get('dynamicFields') as FormArray;
      const payload: { [key: string]: any } = {};
      dynamicFieldsArray.controls.forEach((fieldGroup: AbstractControl) => {
        const field = fieldGroup.value;
        const controlName = field.formControlName;
        const value = field.value;
        const otherText = field.otherText;
        const fieldName = field.fieldName;
        payload[controlName] = {
          question: fieldName,
          answer: value
        };
        if (field.needTextbox && otherText?.trim()) {
          payload[`${controlName}_other`] = otherText;
        }
      });
      const data = {
        dynamicFields: payload,
        institutionId: this.institutesId,
        questionnarieQusId: this.quesId,
        email: this.activeTab === 'mentor' ? '' : this.dynamicForm.value.email,
        name: this.dynamicForm.value.name.trim(),
        year: this.activeTab === 'mentor' ? '' : this.dynamicForm.value.year,
        address: this.dynamicForm.value.address,
        formSubmittedBy: this.activeTab
      };
      this.spinner = true;
      this.questionnarieService.addQuestionnarie(data).subscribe({
        next: (res) => {
          this.spinner = false;
          if (res.status) {
            this.toastr.success(res.message);
            this.isCallViewPage = true;
            this.studentId = res.data.readingProfile.studentId;
            this.questionId = res.data.readingProfile.questionnarieQusId;
            this.index = res.data.count;
            this.router.navigate(["/institute/" + this.studentId + "/questionnarie-view-Table/" + this.questionId + "/" + this.index + '/sendEmail/' + this.institutesId], { queryParams: { activetab: this.activeTab } });
            this.isDynamicFormSubmitted = false;
            this.resetForm();
          } else {
            this.toastr.error(res.err?.message);
          }
        }
      });
    } else {
      this.spinner = false;
      this.cdr.detectChanges();
    }
  }

  copyLinkToClipboard() {
    const route = `institute/${this.institutesId}/questionnarie/${this.quesId}`;
    const baseUrl = environment.fDomainName;
    const fullUrl = baseUrl + route;
    this.clipboard.copy(fullUrl);
    this.copyLinkRoute = fullUrl;
    this.toastr.success("Link copied to your clipboard !");
  }

  getInstitutionById() {
    this.InstitutionService.getInstitutionByID(this.institutionIdByRoute).subscribe(res => {
      if (res.status) {
        this.InsName = res.data.name;
      }
    });
  }

  downloadPdf() {
    this.showName = true;
    const element = document.getElementById('pdf-content');
    if (!element) {
      this.spinner = false;
      this.cdr.detectChanges();
      this.toastr.error('PDF content element not found');
      return;
    }
    this.spinner = true;
    this.cdr.detectChanges();
    const pdfOnlyElements = document.querySelectorAll('.show-only-in-pdf');
    const validationErrors = document.querySelectorAll('.hide-in-pdf');
    validationErrors.forEach(el => el.classList.remove('d-none'));
    const options = {
      margin: 0.2,
      filename: 'QuestionnarieForm.pdf',
      html2canvas: {
        scale: 2,
        useCORS: true,
        scrollX: 0,
        scrollY: 0,
        windowWidth: document.body.scrollWidth,
        windowHeight: document.body.scrollHeight,
        onclone: (clonedDoc: any) => {
          clonedDoc.querySelectorAll('input').forEach((input: HTMLInputElement) => {
            if (input.type === 'radio' || input.type === 'checkbox') {
              input.checked = false;
            } else {
              input.value = '';
            }
          });
          clonedDoc.querySelectorAll('textarea').forEach((textarea: HTMLTextAreaElement) => {
            textarea.value = '';
          });
          clonedDoc.querySelectorAll('.hide-in-pdf').forEach((el: HTMLElement) => {
            el.classList.add('d-none');
          });
          const style = clonedDoc.createElement('style');
          style.innerHTML = `
             .show-only-in-pdf { display: block !important; }
             .questionnnarie-card { width: 100% !important; }
             .question-block, .form-group, .form-section, .questionnnarie-card { page-break-inside: avoid !important; break-inside: avoid !important; }
             .card-footer { margin-top: 0.5pc !important; }
             .logo-img { height: 50px !important; }
             .first-page { margin-top: 4.8pc !important; }
          `;
          clonedDoc.head.appendChild(style);
        }
      },
      jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' }
    };
    html2pdf().set(options).from(element).save()
      .then(() => {
        validationErrors.forEach(el => el.classList.add('d-none'));
        pdfOnlyElements.forEach(el => el.classList.add('show-only-in-pdf'));
        this.resetForm();
        this.spinner = false;
        this.cdr.detectChanges();
      })
      .catch((err: any) => {
        console.error("PDF generation failed:", err);
        validationErrors.forEach(el => el.classList.add('d-none'));
        pdfOnlyElements.forEach(el => el.classList.add('show-only-in-pdf'));
        this.spinner = false;
        this.cdr.detectChanges();
      });
  }

  resetForm() {
    this.isDynamicFormSubmitted = false;
    this.dynamicForm.get('name')?.reset();
    this.dynamicForm.get('email')?.reset();
    this.dynamicForm.get('year')?.reset();
    this.dynamicForm.get('address')?.reset();

    const fieldsArray = this.dynamicForm.get('dynamicFields') as FormArray;
    fieldsArray.controls.forEach((fieldGroup: AbstractControl) => {
      const control = fieldGroup.get('value');
      if (control) {
        control.reset(Array.isArray(control.value) ? [] : '');
      }
      fieldGroup.get('otherText')?.reset();
      const fieldType = fieldGroup.get('fieldType')?.value;
      let showOther = false;

      if (fieldType === 'checkbox' || fieldType === 'multiselect') {
        const currentVal = fieldGroup.get('value')?.value || [];
        showOther = this.otherOptions.some(opt => currentVal.includes(opt));
      } else if (fieldType === 'radio' || fieldType === 'select') {
        const currentVal = fieldGroup.get('value')?.value || '';
        showOther = this.otherOptions.includes(currentVal);
      }
      fieldGroup.get('showOtherInput')?.setValue(showOther);
    });
    this.cdr.detectChanges();
  }

  onFileChange(event: Event, fieldIndex: number): void {
    const input = event.target as HTMLInputElement;
    if (input.files?.length) {
      const file = input.files[0];
      this.dynamicFields.at(fieldIndex).get('value')?.setValue(file);
    }
  }

  getAbsoluteFieldIndex(groupIndex: number, fieldIndexInGroup: number): number {
    let absoluteIndex = 0;
    const chunkedFields = this.getChunkedFields();
    for (let i = 0; i < groupIndex; i++) {
      absoluteIndex += chunkedFields[i].length;
    }
    return absoluteIndex + fieldIndexInGroup;
  }

  onCheckboxChange(event: any, groupIndex: number, i: number) {
    const index = this.getAbsoluteFieldIndex(groupIndex, i);
    const control = this.dynamicFields.at(index);
    const currentVal = control.get('value')?.value || [];

    if (event.target.checked) {
      currentVal.push(event.target.value);
    } else {
      const idx = currentVal.indexOf(event.target.value);
      if (idx > -1) currentVal.splice(idx, 1);
    }
    control.get('value')?.setValue([...currentVal]);

    const hasOther = currentVal.some((val: string) => this.otherOptions.includes(val?.toLowerCase()));
    const needTextbox = control.get('needTextbox')?.value === true;

    control.get('showOtherInput')?.setValue(hasOther && needTextbox);
    if (!(hasOther && needTextbox)) {
      control.get('otherText')?.setValue('');
    }
    this.cdr.detectChanges();
  }

  onRadioChange(value: string, groupIndex: number, i: number) {
    const index = this.getAbsoluteFieldIndex(groupIndex, i);
    const control = this.dynamicFields.at(index);

    const hasOther = this.otherOptions.includes(value?.toLowerCase());
    const needTextbox = control.get('needTextbox')?.value === true;

    control.get('value')?.setValue(value);
    control.get('showOtherInput')?.setValue(hasOther && needTextbox);
    if (!(hasOther && needTextbox)) {
      control.get('otherText')?.setValue('');
    }
    this.cdr.detectChanges();
  }

  onSelectChange(event: any, groupIndex: number, i: number) {
    const index = this.getAbsoluteFieldIndex(groupIndex, i);
    const control = this.dynamicFields.at(index);
    const val = event.target.value;
    const hasOther = this.otherOptions.includes(val?.toLowerCase());
    const needTextbox = control.get('needTextbox')?.value === true;
    control.get('showOtherInput')?.setValue(hasOther && needTextbox);
    if (!(hasOther && needTextbox)) {
      control.get('otherText')?.setValue('');
    }
    this.cdr.detectChanges();
  }

  onMultiSelectChange(event: any, groupIndex: number, i: number) {
    const index = this.getAbsoluteFieldIndex(groupIndex, i);
    const control = this.dynamicFields.at(index);
    const currentVal = event || [];
    const hasOther = currentVal.some((val: string) => this.otherOptions.includes(val?.toLowerCase()));
    const needTextbox = control.get('needTextbox')?.value === true;
    control.get('showOtherInput')?.setValue(hasOther && needTextbox);
    if (!(hasOther && needTextbox)) {
      control.get('otherText')?.setValue('');
    }
    this.cdr.detectChanges();
  }
}